import { render, staticRenderFns } from "./species.vue?vue&type=template&id=850a9368&scoped=true&"
import script from "./species.vue?vue&type=script&lang=js&"
export * from "./species.vue?vue&type=script&lang=js&"
import style0 from "./species.vue?vue&type=style&index=0&id=850a9368&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850a9368",
  null
  
)

export default component.exports